import type { InboxMessage, InboxSummary } from "../types/inbox";

export const INBOX_SUMMARY_REQUEST = "INBOX_SUMMARY_REQUEST";
export const INBOX_SUMMARY_SUCCESS = "INBOX_SUMMARY_SUCCESS";
export const INBOX_SUMMARY_FAILURE = "INBOX_SUMMARY_FAILURE";
export const INBOX_LIST_REQUEST = "INBOX_LIST_REQUEST";
export const INBOX_LIST_SUCCESS = "INBOX_LIST_SUCCESS";
export const INBOX_LIST_FAILURE = "INBOX_LIST_FAILURE";
export const INBOX_MESSAGE_RECEIVED = "INBOX_MESSAGE_RECEIVED";
export const INBOX_SET_READ = "INBOX_SET_READ";

export type InboxReduxAction =
  | { type: typeof INBOX_SUMMARY_REQUEST; payload: { accountUuid: string } }
  | {
      type: typeof INBOX_SUMMARY_SUCCESS;
      payload: { accountUuid: string; summary: InboxSummary };
    }
  | { type: typeof INBOX_SUMMARY_FAILURE; payload: { accountUuid: string } }
  | { type: typeof INBOX_LIST_REQUEST; payload: { accountUuid: string } }
  | {
      type: typeof INBOX_LIST_SUCCESS;
      payload: {
        accountUuid: string;
        messages: InboxMessage[];
        latestUpdatedAt: string | null;
      };
    }
  | { type: typeof INBOX_LIST_FAILURE; payload: { accountUuid: string } }
  | {
      type: typeof INBOX_MESSAGE_RECEIVED;
      payload: { accountUuid: string; message: InboxMessage };
    }
  | {
      type: typeof INBOX_SET_READ;
      payload: {
        accountUuid: string;
        id: string;
        read: boolean;
        previousRead: boolean;
      };
    };

export const inboxSummaryRequest = (accountUuid: string): InboxReduxAction => ({
  type: INBOX_SUMMARY_REQUEST,
  payload: { accountUuid },
});

export const inboxSummarySuccess = (
  accountUuid: string,
  summary: InboxSummary,
): InboxReduxAction => ({
  type: INBOX_SUMMARY_SUCCESS,
  payload: { accountUuid, summary },
});

export const inboxSummaryFailure = (accountUuid: string): InboxReduxAction => ({
  type: INBOX_SUMMARY_FAILURE,
  payload: { accountUuid },
});

export const inboxListRequest = (accountUuid: string): InboxReduxAction => ({
  type: INBOX_LIST_REQUEST,
  payload: { accountUuid },
});

export const inboxListSuccess = (
  accountUuid: string,
  messages: InboxMessage[],
  latestUpdatedAt: string | null,
): InboxReduxAction => ({
  type: INBOX_LIST_SUCCESS,
  payload: { accountUuid, messages, latestUpdatedAt },
});

export const inboxListFailure = (accountUuid: string): InboxReduxAction => ({
  type: INBOX_LIST_FAILURE,
  payload: { accountUuid },
});

export const inboxMessageReceived = (
  accountUuid: string,
  message: InboxMessage,
): InboxReduxAction => ({
  type: INBOX_MESSAGE_RECEIVED,
  payload: { accountUuid, message },
});

export const inboxSetRead = (
  accountUuid: string,
  id: string,
  read: boolean,
  previousRead: boolean,
): InboxReduxAction => ({
  type: INBOX_SET_READ,
  payload: { accountUuid, id, read, previousRead },
});
